/**
 * Gets a Lineup based on an id (at present we gather these from the D&L team)
 *
 * Explore options here:
 * https://studio.apollographql.com/graph/pocket-client-api/explorer?explorerURLState=N4IgJg9gxgrgtgUwHYBcQC4QEcYIE4CeABAOIIoDKANgIYoIAyAlkgjAA4AUAJE2OkQoo8LAOYBCADRFueBFAhxESMHSYQkAYQgxUAgJKoAlEWAAdJEStFR5anUYs2XAM616zVh338ZfaXIKSsiqKOpaOnoygYrKoeHauigm5pbWVggAHuz4TMooPhbpVnxFxW4OLqZlxUSlabVgTC7stAQAcjSINcVgCC5QIuxhGj3pMcEqahpVqbXpTPRw1Q3zVnIuEFQAbghghatriwhwB2vpYShUCGPzWVD4w7e1oky7SACqeFTPxUgQeDgNCoXx%2Bh3mGy2uzAoN%2B6UgQJYcOsCJoLAAsuQaKEaCtzn8ujdwbUAL7IkouACCeDCUGu5KIAAsaC4AGp8BAQBnMlz6IG2BkoCDsPk0Wyw4nFPJi-p4-HWKA0YbhBlWQZ7RaqoguPBQBlkyXpADuALAiVQgryCAAKhAAEoIbEMlwEFRMRX0MDU2nXOXy7VUGCifXIg34%2Br42B4Bz7JAAMwgfvOl3phus90eKAZ0tsFF1od%2BYeKRasRZJIEkIG2NBENAARtcXBgQHMiGYQKUMG2QFAAIwADjrABZe2B%2BwBafu9gAM0-HQ%2BnAGYAOzjmg0ABsQ-nvY3AE490OEKOh1A4%2B2LOWSUA&variant=current
 *
 * Slate: Corpus of recommendations based on a particular concept (topic, curation, personalized, etc.)
 * Lineup: Set of slates generated from different sources (curation, algorithms, etc.)
 *
 */

import { gql } from 'graphql-request'
const getSlateLineup = gql`
  query GetSlateLineup($id: String!, $recommendationCount: Int) {
    getSlateLineup(slateLineupId: $id, recommendationCount: $recommendationCount) {
      experimentId
      requestId
      id
      slates {
        id
        requestId
        experimentId
        displayName
        description
        recommendations {
          item {
            isArticle
            title
            itemId
            normalUrl
            resolvedId
            resolvedUrl
            domain
            domainMetadata {
              name
            }
            excerpt
            hasImage
            hasVideo
            images {
              caption
              credit
              height
              imageId
              src
              width
            }
            topImageUrl
            wordCount
            timeToRead
            givenUrl
            syndicatedArticle {
              slug
              publisher {
                name
                url
              }
            }
          }
          id
          curatedInfo {
            title
            excerpt
            imageSrc
          }
        }
      }
    }
  }
`

export default getSlateLineup
